import { Component, Input } from '@angular/core';
import { BlockCardComponent, CardType } from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-client-block-card',
    templateUrl: './block-card.component.html',
    standalone: false,
})
export class BlockClientCardComponent extends BlockCardComponent {
    @Input() zone?: string;
    @Input() parentUrl?: string;
    @Input() pageGradient?: string;

    override ngOnInit(): void | false {
        super.ngOnInit();
        this.imageUrl = this.imageService.getImageUrl(this.card, 'card');
    }

    override cardNameId(card: CardType) {
        return 'card-' + card.name.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-');
    }

    fullUrl(card: CardType) {
        if (this.parentUrl) {
            return this.parentUrl + '/' + card.url;
        } else {
            return this.zone + '/' + card.url;
        }
    }
}
